/**
 * @author Ka Wing Chin (kawing.chin@takeaway.com)
 * @class Takeaway.ActiveDiscount
 */

import Utils from '../lib/utils'

export default class ActiveDiscount {
  constructor () {
    this.productNames = []
  }

  id
  price
  totalPrice
  /**
   * Don't count
   */
  excludeMinimumOrder = 0
  movDiscount = 0
  discountName
  description
  count
  productNames

  /**
   * Update the total discount price.
   */
  updateTotalPrice () {
    this.totalPrice = Utils.toMoney((this.price * this.count), 2)
  }
}
